/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import no_user from "../../../../assets/img/avatar5.png";
import LogoImg from "../../../../assets/img/AdminLTELogo.png";
import "../Sidebar/Sidebar.css";
import { GetService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import { showErrorAlert } from "../../../../Helper/SweetAlert";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function Sidebar() {
  const navigate = useNavigate();

  function Signout() {
    const retainedValue = localStorage.getItem("AdminData");
    localStorage.clear();
    if (retainedValue !== null) {
      localStorage.setItem("AdminData", retainedValue);
    }
    navigate("/login");
  }

  function GetExportData() {
    GetService(API_URL.GET_LIST_TO_EXPORT).then(
      (res) => {
        console.log(res);
        if (res.data.status === true) {
          // setLoading(false);
          exportToExcel(res.data.data);
        } else {
          showErrorAlert(res.data?.message);
          // setLoading(false);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
        // setLoading(false);
      },
    );
  }

  const exportToExcel = (userData) => {
    const ws = XLSX.utils.json_to_sheet(userData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Users");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const fileName = "Data.xlsx";
    saveAs(blob, fileName);
  };

  return (
    <div>
      <nav className="sidebar sidebar-offcanvas scrollsidebar" id="sidebar">
        <ul className="nav">
          {/* dashboard */}
          <li className="nav-item">
            <NavLink to={"/panel/dashboard"} className="nav-link">
              <i className="icon-grid menu-icon" />
              <span className="menu-title">Dashboard</span>
            </NavLink>
          </li>
          {/* user */}
          <li className="nav-item">
            <NavLink to={"/panel/user"} className="nav-link">
              <i class="fa-solid fa-user menu-icon"></i>
              <span className="menu-title">Users</span>
            </NavLink>
          </li>
          {/* affiliate user */}
          <li className="nav-item">
            <a
              className="nav-link"
              data-toggle="collapse"
              aria-expanded="false"
              href="#affiliate"
              aria-controls="affiliate"
            >
              <i className="fa-solid fa-user-tag menu-icon" />
              <span className="menu-title">Affiliate</span>
              <i className="menu-arrow" />
            </a>
            <div className="collapse" id="affiliate">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"affiliate-user"}>
                    Affiliate Users
                  </NavLink>
                </li>
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"affiliate-commission"}>
                    Affiliate Commission
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          {/* category */}
          <li className="nav-item">
            <a
              className="nav-link"
              data-toggle="collapse"
              aria-expanded="false"
              href="#category"
              aria-controls="category"
            >
              <i className="icon-layout menu-icon" />
              <span className="menu-title">Categories</span>
              <i className="menu-arrow" />
            </a>
            <div className="collapse" id="category">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"Print/diamond_dust"}>
                    Diamond Dust
                  </NavLink>
                </li>
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"Print/plexi_print"}>
                    Plexi Print
                  </NavLink>
                </li>
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"Print/art_tray"}>
                    Art Tray
                  </NavLink>
                </li>
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"Print/wood_print"}>
                    Print On Wood
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          {/* canvascategory */}
          <li className="nav-item">
            <a
              className="nav-link"
              data-toggle="collapse"
              aria-expanded="false"
              href="#canvascategory"
              aria-controls="canvascategory"
            >
              <i className="icon-layout menu-icon" />
              <span className="menu-title">Canvas Categories</span>
              <i className="menu-arrow" />
            </a>
            <div className="collapse" id="canvascategory">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"CanvasPrint"}>
                    Single Canvas
                  </NavLink>
                </li>
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"canvasSplits_list"}>
                    Split Canvas
                  </NavLink>
                </li>
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"canvas_wall/gallery_wall"}>
                    Gallery Wall
                  </NavLink>
                </li>
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"canvas_wall/story_canvas"}>
                    Story Canvas
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
          {/* product */}
          <li className="nav-item">
            <NavLink to={"/panel/product"} className="nav-link">
              <i className="fa fa-database menu-icon" />
              <span className="menu-title">Our Products</span>
            </NavLink>
          </li>

          {/* order */}
          <li className="nav-item">
            <NavLink to={"/panel/order"} className="nav-link">
              <i className="fa fa-shopping-bag menu-icon" />
              <span className="menu-title">Orders List</span>
            </NavLink>
          </li>

          {/* Transaction */}
          <li className="nav-item">
            <NavLink to={"/panel/transaction"} className="nav-link">
              <i className="fa fa-exchange menu-icon" />
              <span className="menu-title">Transactions List</span>
            </NavLink>
          </li>

          {/* canvas frames */}
          <li className="nav-item">
            <a
              className="nav-link"
              data-toggle="collapse"
              aria-expanded="false"
              href="#canvas-container"
              aria-controls="category"
            >
              <i className="fa fa-film menu-icon" />
              <span className="menu-title">Edges/Frames</span>
              <i className="menu-arrow" />
            </a>
            <div className="collapse" id="canvas-container">
              <ul className="nav flex-column sub-menu">
                {/* <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"Image_listing"}>
                    Images
                  </NavLink>
                </li> */}
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"Edge_listing"}>
                    Edges
                  </NavLink>
                </li>
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"frames"}>
                    Frames
                  </NavLink>
                </li>
                {/* <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"gallery_wall_configs"}>
                    Gallery Wall Configs
                  </NavLink>
                </li> */}
              </ul>
            </div>
          </li>

          {/* digital services list*/}
          <li className="nav-item">
            <NavLink to={"/panel/digital_services"} className="nav-link">
              <i class="fa fa-list-alt menu-icon"></i>
              <span className="menu-title">digital services list</span>
            </NavLink>
          </li>

          {/* price list for app*/}
          {/* <li className="nav-item">
            <NavLink to={"/panel/price_list"} className="nav-link">
              <i class="fa fa-usd menu-icon"></i>
              <span className="menu-title">prices List</span>
            </NavLink>
          </li> */}

          {/* shipping */}
          <li className="nav-item">
            <a
              className="nav-link"
              data-toggle="collapse"
              aria-expanded="false"
              href="#shipping"
              aria-controls="category"
            >
              <i class="fa-solid fa-truck-fast menu-icon"></i>
              <span className="menu-title">Shipping</span>
              <i className="menu-arrow" />
            </a>
            <div className="collapse" id="shipping">
              <ul className="nav flex-column sub-menu">
                {/* <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"shipping_information"}>
                    Shipping Charge
                  </NavLink>
                </li> */}
                {/* <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"shipping_charges"}>
                    Shipping Charge
                  </NavLink>
                </li> */}
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"delivery_partner"}>
                    Delivery Partner
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          {/* wall display list */}
          {/* <li className="nav-item">
            <NavLink to={"/panel/wall_display_list"} className="nav-link">
              <i class="fa-solid fa-list menu-icon"></i>
              <span className="menu-title">wall display list</span>
            </NavLink>
          </li>  */}

          {/* canvasSplits list */}
          {/* <li className="nav-item">
            <NavLink to={"/panel/canvasSplits_list"} className="nav-link">
              <i class="fa fa-bars menu-icon"></i>
              <span className="menu-title">Canvas Splits List</span>
            </NavLink>
          </li> */}

          {/* sales tax*/}
          {/* <li className="nav-item">
            <NavLink to={"/panel/sales_tax"} className="nav-link">
              <i class="fa-solid fa-business-time menu-icon"></i>
              <span className="menu-title">Sales Tax</span>
            </NavLink>
          </li> */}

          {/* coupon*/}
          <li className="nav-item">
            <NavLink to={"/panel/coupon"} className="nav-link">
              <i className="fa fa-ticket menu-icon" />
              <span className="menu-title">Coupons</span>
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink to={"/panel/faq_list"} className="nav-link">
              <i class="fa-solid fa-question menu-icon"></i>
              <span className="menu-title">FAQ</span>
            </NavLink>
          </li>

          {/* content */}
          {/* <li className="nav-item">
            <NavLink to={"/panel/content"} className="nav-link">
              <i className="fa fa-cubes menu-icon" />
              <span className="menu-title">Content Management</span>
            </NavLink>
          </li> */}

          <li className="nav-item">
            <a
              className="nav-link"
              data-toggle="collapse"
              href="#cms"
              aria-expanded="false"
              aria-controls="cms"
            >
              <i className="fa fa-cubes menu-icon" />
              <span className="menu-title">Content Management</span>
              <i className="menu-arrow" />
            </a>
            <div className="collapse" id="cms">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"privacy-policy"}>
                    Privacy Policy
                  </NavLink>
                </li>
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"terms-condition"}>
                    Terms & Condition
                  </NavLink>
                </li>
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"bio-video"}>
                    Bio & Video
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          <li className="nav-item">
            <NavLink to={"/panel/user_query"} className="nav-link">
              <i class="fa fa-commenting menu-icon"></i>
              <span className="menu-title">Users Query</span>
            </NavLink>
          </li>

          {/* gift vouchers*/}
          {/* <li className="nav-item">
            <NavLink to={"/panel/gift_cards"} className="nav-link">
              <i class="fa-solid fa-gift menu-icon"></i>
              <span className="menu-title">Gift Cards</span>
            </NavLink>
          </li> */}

          {/* index banner*/}
          {/* <li className="nav-item">
            <NavLink to={"/panel/banner"} className="nav-link">
              <i className="fa fa-info-circle menu-icon" />
              <span className="menu-title">banner</span>
            </NavLink>
          </li> */}

          {/* Seo list*/}
          {/* <li className="nav-item">
            <NavLink to={"/panel/seo_listing"} className="nav-link">
              <i class="fa-solid fa-globe menu-icon"></i>
              <span className="menu-title">Manage SEO</span>
            </NavLink>
          </li> */}

          {/* State list*/}
          {/* <li className="nav-item">
            <NavLink to={"/panel/states"} className="nav-link">
              <i class="fa-solid fa-globe menu-icon"></i>
              <span className="menu-title">States List</span>
            </NavLink>
          </li> */}

          {/* Header Image list*/}
          {/* <li className="nav-item">
            <NavLink to={"/panel/header_image_listing"} className="nav-link">
              <i class="fa-solid fa-image menu-icon"></i>
              <span className="menu-title">Header Images Listing</span>
            </NavLink>
          </li> */}

          {/* mail content list*/}
          {/* <li className="nav-item">
            <NavLink to={"/panel/mail_list"} className="nav-link">
              <i class="fa-solid fa-envelope menu-icon"></i>
              <span className="menu-title">mail content list</span>
            </NavLink>
          </li> */}

          {/* personal shopper list*/}
          {/* <li className="nav-item">
            <NavLink to={"/panel/personal_shopper_list"} className="nav-link">
              <i class="fa fa-list-ol menu-icon"></i>
              <span className="menu-title">personal shopper list</span>
            </NavLink>
          </li> */}

          {/* top questions list*/}
          {/* <li className="nav-item">
            <NavLink to={"/panel/question_list"} className="nav-link">
              <i class="fa fa-question menu-icon"></i>
              <span className="menu-title">top questions list</span>
            </NavLink>
          </li> */}

          {/* footer name list*/}
          {/* <li className="nav-item">
            <NavLink to={"/panel/footer_name_list"} className="nav-link">
              <i class="fa-solid fa-list menu-icon"></i>
              <span className="menu-title">footer names list</span>
            </NavLink>
          </li> */}

          {/* company details */}
          <li className="nav-item">
            <NavLink to={"/panel/company_details"} className="nav-link">
              <i className="fa fa-life-ring menu-icon" />
              <span className="menu-title">company details</span>
            </NavLink>
          </li>

          {/* payment credentails*/}
          <li className="nav-item">
            <NavLink to={"/panel/payment_credentails"} className="nav-link">
              <i class="fa-solid fa-money-bill menu-icon"></i>
              <span className="menu-title">payment credentials</span>
            </NavLink>
          </li>

          {/* <li className="nav-item">
            <NavLink to={"/panel/email_temp"} className="nav-link">
            <i class="fa fa-envelope menu-icon"></i> 
              <span className="menu-title">Email Template</span>
            </NavLink>
          </li> */}

          {/* customer mangement */}
          {/* <li className="nav-item">
            <a
              className="nav-link"
              data-toggle="collapse"
              aria-expanded="false"
              href="#customerMangement"
              aria-controls="category"
            >
              <i className="fa fa-universal-access menu-icon" />
              <span className="menu-title">customer mangement</span>
              <i className="menu-arrow" />
            </a>
            <div className="collapse" id="customerMangement">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" onClick={GetExportData}>
                    export customers
                  </NavLink>
                </li>
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"company_details"}>
                    customer email
                  </NavLink>
                </li>
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"cart_mail"}>
                    cart mail
                  </NavLink>
                </li>
              </ul>
            </div>
          </li> */}

          {/* settings */}
          <li className="nav-item">
            <a
              className="nav-link"
              data-toggle="collapse"
              href="#settings"
              aria-expanded="false"
              aria-controls="settings"
            >
              <i class="fa-solid fa-gear menu-icon"></i>
              <span className="menu-title">Settings</span>
              <i className="menu-arrow" />
            </a>
            <div className="collapse" id="settings">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"profile"}>
                    Profile
                  </NavLink>
                </li>
                <li className="nav-item">
                  {" "}
                  <NavLink className="nav-link" to={"change-password"}>
                    Change Password
                  </NavLink>
                </li>
                <li className="nav-item">
                  {" "}
                  <button className="btn nav-link pointer" onClick={Signout}>
                    LogOut
                  </button>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </nav>
      {/* partial */}
    </div>
  );
}
